<div class="modal-header bg-dark">
    <h4 class="modal-title">Accessi pratica <strong>{{ request.IDRequest }}</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body">
    <div *ngIf="!loading && loadFailed" class="access-empty">Impossibile caricare gli accessi.</div>
    <div *ngIf="!loading && !loadFailed && accesses.length === 0" class="access-empty">Nessun accesso registrato.</div>
    <div *ngIf="!loading && !loadFailed && accesses.length > 0" class="table-container table-scroll">
        <table class="table table-hover table-access">
            <thead>
            <tr>
                <th>Data e ora</th>
                <th>Tipo</th>
                <th>Accesso effettuato da</th>
                <th>Indirizzo IP</th>
                <th class="col-wrap">Browser</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let access of accesses">
                <td>{{ access.AccessDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>
                    <span class="badge" [class.badge-primary]="access.IsAuthenticated" [class.badge-info]="!access.IsAuthenticated">{{ getAccessorType(access) }}</span>
                </td>
                <td>{{ getAccessorName(access) }}</td>
                <td>{{ access.IPAddress || '-' }}</td>
                <td class="col-wrap">{{ access.UserAgent || '-' }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
</div>
